import {
  Box,
  ButtonBase,
  Typography,
  MenuItem,
  Select,
  FormControl,
  IconButton,
} from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import LoadingPage from "../../Loader";
import Footer from "../home/Footer";
import logo from "../../assets/icons/logo-blog.png";
import { useSearchParams } from "react-router-dom";

import SearchIcon from "@mui/icons-material/Search";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const About = () => {
  const [modules, setModules] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [category, setCategory] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getData } = useAuth();
  const [searchParams] = useSearchParams();
  const [projects, setProjects] = useState();
  const navigate = useNavigate();
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const catgry = searchParams.get("cat");
    setSelectedCategory(catgry || "");
  }, [searchParams]);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        setError(null);

        const response = await getData("proccess.php", "modules_V2"); // Fetch adverts data
        if (response.success) {
          const sortedModules = [...response.data].sort((a, b) => {
            const orderA = Number(a.listing_Order) || 0;
            const orderB = Number(b.listing_Order) || 0;
            return orderA - orderB;
          });
          setModules(sortedModules);
        } else {
          console.error(response.message || "Failed to load Modules");
        }

        const prog = await getData("proccess.php", "projects_V2"); // Fetch adverts data
        if (prog.success) {
          setProjects(prog.data);
        } else {
          console.error(prog.message || "Failed to load Modules");
        }

        const cate = await getData("proccess.php", "our_clients_V2"); // Fetch adverts data
        if (cate.success) {
          setCategory(cate.data);
        } else {
          console.error(cate.message || "Failed to load Modules");
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Failed to load data. Please try again later.");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [getData]); // Added dependency array

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -300,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 300,
        behavior: "smooth",
      });
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <Box
        minHeight="100vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  // Filter modules based on selected category and search term
  const filteredModules = modules.filter(
    (module) =>
      module.categories === selectedCategory &&
      (module.module_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        module.short_description
          .toLowerCase()
          .includes(searchTerm.toLowerCase()))
  );

  // Fallback background image if imagebackground[0] is undefined
  const backgroundImage = `https://mindsinaction.com.na/assets/media/pictures/${
    category.find((cat) => cat.categories === selectedCategory)?.image || ""
  }`;

  const handleModuleLinkClick = (url) => {
    navigate(url);
  };

  const handleCategoryLinkClick = (url) => {
    navigate(url);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="parentContainer">
      <Box
        position={"relative"}
        minHeight={"50vh"}
        width={"100%"}
        sx={{
          backgroundColor: "#ffffffff",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          zIndex: 1,
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "1200px",
            minHeight: "50vh",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            zIndex: 2,
            padding: "1rem",
            marginTop: "100px",
            marginBottom: "50px",
          }}
        >
          <Box
            sx={{
              flex: 1,
              minWidth: "300px",
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "center",
              position: "relative",
              zIndex: 100,
              padding: "1rem",
            }}
          >
            {category.length > 0 &&
              category.map(
                (cat) =>
                  cat.categories === selectedCategory && (
                    <>
                      <h1 className="primary-header">{cat.title}</h1>
                      <p
                        style={{
                          color: "#000000ff",
                          textAlign: "start",
                          marginTop: "2rem",
                          fontSize: "1.2rem",
                        }}
                      >
                        {cat.description}
                      </p>
                      
                      <Box sx={{
                        width: '100%',
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '1rem'
                      }}>
                        {filteredModules.length > 0 ? (
                          filteredModules.map((module) => (
                            <Box
                              key={module.id}
                              sx={{
                                flex: "0 0 auto",
                                width: 'auto',
                                height: "auto",
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                              }}
                            >
                              <Box
                                sx={{
                                  width: "100%",
                                  height: "100%",
                                  background: "linear-gradient(to right, #3b76b2 ,#32a059)",
                                  borderRadius: "1rem",
                                  position: "relative",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  overflow: "hidden",
                                }}
                              >
                                <Link
                                      to={`/modules/${module.categories}/?code=${module.id}`}
                                    >
                                      <ButtonBase
                                        sx={{
                                          backgroundColor: "#ffffff11",
                                          color: "#fff",
                                          padding: ".5rem 1rem",
                                          borderRadius: "1rem",
                                        }}
                                      >
                                        {module.module_name}
                                      </ButtonBase>
                                    </Link>
                              </Box>
                            </Box>
                          ))
                        ) : (
                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "2rem",
                            }}
                          >
                            <Typography variant="h6">
                              
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </>
                  )
              )}
          </Box>

          <Box
            sx={{
              flex: 1,
              minWidth: "300px",
              maxWidth: "600px",
              maxHeight: "350px",
              overflow: "hidden",
              borderRadius: "1rem",
            }}
          >
            {backgroundImage && (
              <img
                src={`${backgroundImage}`}
                style={{
                  width: "100%",
                  height: "100%",
                }}
                alt={selectedCategory}
              />
            )}
          </Box>
        </Box>
      </Box>

      <Box
        width={"100%"}
        height={"auto"}
        sx={{
          backgroundColor: "#e7f1f5",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          width={"100%"}
          maxWidth={"1200px"}
          height={"auto"}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "1rem",
          }}
        >

          {/* Other Categories Section */}
          <Box width={"100%"}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                borderBottom: ".1rem solid #3b76b2",
              }}
            >
              <Typography
                sx={{
                  backgroundColor: "#3b76b2",
                  padding: "1rem",
                  color: "#fff",
                }}
              >
                Other Categories
              </Typography>
            </Box>
            <Box
              sx={{
                width: { xs: "100%", sm: "100%", ms: "100%" },
                display: "flex",
                flexWrap: "wrap",
                gap: "2rem",
                alignItems: "start",
                justifyContent: "center",
                marginTop: "50px",
              }}
            >
              {category.map((client) => (
                <Box
                  key={client.id}
                  sx={{
                    width: "200px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    className="box-hover"
                    sx={{
                      position: "relative",
                      width: { xs: "300px", sm: "200px" },
                      height: { xs: "300px", sm: "100px" },
                      borderRadius: "40px",
                      overflow: "hidden",
                      margin: { xs: "0", sm: "0" },
                    }}
                  >
                    {/* Scroll to the top also on click */}
                    <ButtonBase
                      onClick={() => {
                        handleCategoryLinkClick(
                          `/modules/category/${client.categories}/?cat=${client.categories}`
                        );
                        scrollToTop(); // Add this line
                      }}
                      sx={{ width: "100%", height: "100%" }}
                    >
                      <img
                        src={
                          client.image
                            ? `https://mindsinaction.com.na/assets/media/pictures/${client.image}`
                            : null
                        }
                        alt="STEAM Logo"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </ButtonBase>
                  </Box>
                  <Typography
                    variant="h6"
                    textAlign="center"
                    color="#39aa22ff"
                    fontWeight={700}
                    fontSize={"1rem"}
                  >
                    {client.title}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default About;
